module.exports = __webpack_public_path__ + "static/media/foto 2 dirigentes liberados tras participar en protesta.e0c39506.jpg";